import { useState } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { useSignupMutation } from '@/domains/auth/queries'
import { useAppForm } from '@/lib/form'
import {
  signupFormOpts,
  signupFormSchema,
} from '@/domains/auth/form/form-options'
import { SignupForm } from '@/domains/auth/form/auth-form'
import { GeoBlockDialog } from '@/domains/auth/components/geo-block-dialog'
import { HttpError } from '@/lib/http'

export const Route = createFileRoute('/signup')({
  component: RouteComponent,
})

function RouteComponent() {
  const [geoBlocked, setGeoBlocked] = useState(false)
  const { mutateAsync: signup } = useSignupMutation()

  const form = useAppForm({
    ...signupFormOpts,
    validators: {
      onSubmit: signupFormSchema,
    },
    onSubmit: async ({ value }) => {
      try {
        await signup(value)
      } catch (error) {
        if (error instanceof HttpError && error.status === 403) {
          setGeoBlocked(true)
          return
        }
        throw error
      }
    },
  })

  return (
    <div className="flex-1 flex justify-center items-center overflow-hidden px-5">
      <form
        className="w-full max-w-sm"
        onSubmit={(e) => {
          e.preventDefault()
          form.handleSubmit()
        }}
      >
        <SignupForm
          form={form}
          title="Signup"
          description="Create an account on Powka."
          submitLabel="Sign Up"
        />
      </form>
      <GeoBlockDialog
        open={geoBlocked}
        onRetry={() => {
          setGeoBlocked(false)
          form.handleSubmit()
        }}
      />
    </div>
  )
}
